import React, { useEffect, useState } from "react";
import { Modal } from "reactstrap";
import ReactQuill from "react-quill";
import { useFormik } from "formik";
import QuoteEmailScheme from './validationsEmail'
import InputFloatingLabel from "../../../UI/forms/InputFloatingLabel";
import { useDispatch, useSelector } from "react-redux";
import { sendQuoteEmail } from '../../../../store/factory/factorySlice'
import { useParams } from "react-router-dom";
import { RootState } from "../../../../store/store";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  width?: any;
  IdQuote?:any
}

const modules = {
  toolbar: [
    ["bold", "italic", "underline", "strike"],
    [{ align: [] }],
    [{ "list": "ordered" }, { "list": "bullet" },
    { "indent": "-1" }, { "indent": "+1" }],
    [{ size: [] }],
    [{ color: [] }, { background: [] }],
    ["clean"]
  ],
  clipboard: {
    matchVisual: false,
  }
}
const QuoteEmailModal: React.FC<Props> = (props) => {
  const dispatch = useDispatch()
  const { idjob }: any = useParams();

  const IdQuote = useSelector((state: RootState) => state.factorySlice.IdQuoteEmail);

  useEffect(() => {
    
    console.log("inModal" , IdQuote);
   } , [IdQuote])

  const initialValues = {
    email: "",
    cc: "",
    subject: "",
    content: "",
  }
  const [emailData, setEmailData] = useState<any>(initialValues);

  const handleChange = (prop, value) => {
    setEmailData({
      ...emailData,
      [prop]: value,
    });
  }


  const handleSend = () => {
    dispatch(sendQuoteEmail({data: emailData, id: IdQuote }))
  }

  const formik = useFormik({
    validationSchema: QuoteEmailScheme,
    initialValues: {
      email: "",
      cc: "",
      subject: "",
      content: ""
    } as any,
    onSubmit: (values) => {
    }
  })

  const { setFieldValue, errors } = formik

  return (
    <Modal isOpen={props.isOpen} toggle={props.onClose} centered style={{ maxWidth: props.width || "640px" }}
    >
      <div
        onClick={props.onClose}
        className="cursor-pointer pt-3"
      >
        <i className="bi bi-x-lg px-3"></i>
      </div>
      <div className="container">
        <div className="row px-4 mt-4">
          <div className="col-12 text-center">
            <h3 className="text-secondary fw-bold ">
              Send quote
            </h3>
          </div>
        </div>
        <div className="row px-1 mt-4">
          <div className="col-12 d-flex flex-column">
            <InputFloatingLabel
              value={emailData.clientEmail}
              onChange={(value) => {
                handleChange("email", value)
                setFieldValue('clientemail', value)
              }}
              placeHolder="Client email"
              isRequired={true}
              errorMessage={errors.clientemail}
            />
            <InputFloatingLabel
              value={emailData.cc}
              onChange={(value) => {
                handleChange("cc", value)
                setFieldValue('cc', value)
              }}
              placeHolder="CC"
              errorMessage={errors.cc}
            />
            <InputFloatingLabel
              value={emailData.subject}
              onChange={(value) => {
                handleChange("subject", value)
                setFieldValue('subject', value)
              }}
              placeHolder="Subject"
              isRequired={true}
              errorMessage={errors.subject}
            />
            <div className="mb-3">
              <ReactQuill
                onChange={(value) => handleChange("content", value)}
                value={emailData.content}
                modules={modules}
                placeholder={"Write your message"}
                style={{ height: '150px' }}
              />
            </div>
          </div>
        </div>
        <div className="row px-4 my-5 d-flex justify-content-center">
          <button
            onClick={handleSend}
            className={
              "btn btn-success text-white col-auto fs-6 mt-4"
            }
            style={
              !emailData.email || !emailData.subject || !emailData.content || errors.clientemail || errors.cc ?
                { pointerEvents: 'none', opacity: 0.3 } : {}
            }
          >
            Send
          </button>
        </div>

      </div>
    </Modal>
  );
};

export default QuoteEmailModal;
